export default {
  "首页": "หน้าแรก",
  "订单": "คำสั่งซื้อ",
  "新闻": "ข่าว",
  "个人中心": "ศูนย์ส่วนตัว",
  "模拟账户": "บัญชีจำลอง",
  "可用资产": "สินทรัพย์ที่ใช้ได้",
  "入金": "ฝากเงิน",
  "出金": "ถอนเงิน",
  "账单详情": "รายละเอียดบิล",
  "重置模拟账户": "รีเซ็ตบัญชีจำลอง",
  "钱包": "กระเป๋าเงิน",
  "实名认证": "ยืนยันตัวตน",
  "邀请好友": "เชิญเพื่อน",
  "修改密码": "เปลี่ยนรหัสผ่าน",
  "投诉邮箱": "อีเมลร้องเรียน",
  "其它": "อื่นๆ",
  "公告": "ประกาศ",
  "语言": "ภาษา",
  "是否退出登录": "คุณต้องการออกจากระบบหรือไม่",
  "复制": "คัดลอก",
  "复制成功": "คัดลอกสำเร็จ",
  "发送验证码成功": "ส่งรหัสยืนยันสำเร็จ",
  "请输入密码": "กรุณากรอกรหัสผ่าน",
  "请再次输入密码": "กรุณากรอกรหัสผ่านอีกครั้ง",
  "复制邀请链接": "คัดลอกลิงก์เชิญ",
  "上传身份": "อัปโหลดภาพด้านหน้า/ด้านหลังของพาสปอร์ต/เอกสาร",
  "正面": "ด้านหน้า",
  "上传正面": "อัปโหลดด้านหน้าของพาสปอร์ต/เอกสาร",
  "反面": "ด้านหลัง",
  "上传反面": "อัปโหลดด้านหลังของพาสปอร์ต/เอกสาร",
  "完善信息": "กรุณากรอกข้อมูลส่วนตัว",
  "输入姓名": "กรุณากรอกชื่อของคุณ",
  "身份证号": "หมายเลขพาสปอร์ต/เอกสาร",
  "输入身份证号": "กรุณากรอกหมายเลขพาสปอร์ต/เอกสาร",
  "收款货币": "สกุลเงินที่รับ",
  "银行名称": "ชื่อธนาคาร",
  "收款人账户": "บัญชีผู้รับเงิน",
  "货币": "สกุลเงิน",
  "分店名称": "ชื่อสาขา",
  "绑定银行卡": "ผูกบัตรธนาคาร",
  "银行地址": "ที่อยู่ธนาคาร",
  "账号名称（假名）": "ชื่อบัญชี (ชื่อสมมติ)",
  "绑定数字货币地址": "ผูกที่อยู่สกุลเงินดิจิทัล",
  "余额": "ยอดคงเหลือ",
  "联系客服": "ติดต่อฝ่ายบริการลูกค้า",
  "行情": "ตลาด",
  "其他": "อื่นๆ",
  "设置": "ตั้งค่า",
  "收款人": "ผู้รับเงิน",
  "添加": "เพิ่ม",
  "确认": "ยืนยัน",
  "取消": "ยกเลิก",
  "钱包地址": "ที่อยู่กระเป๋าเงิน",
  "请输入": "กรุณากรอก",
  "退出登录": "ออกจากระบบ",
  "充值数量": "จำนวนที่เติม",
  "提交": "ส่ง",
  "银行卡": "บัตรธนาคาร",
  "选择网络": "เลือกเครือข่าย",
  "数字货币": "สกุลเงินดิจิทัล",
  "上传验证": "อัปโหลดการตรวจสอบ",
  "提币地址": "ที่อยู่การถอน",
  "数量(USD)": "จำนวน (USD)",
  "备注": "หมายเหตุ",
  "手续费": "ค่าธรรมเนียม",
  "预计到账数量": "จำนวนที่คาดว่าจะได้รับ",
  "暂无数据": "ไม่มีข้อมูล",
  "入金记录": "บันทึกการฝากเงิน",
  "提币记录": "บันทึกการถอนเงิน",
  "验证码": "รหัสยืนยัน",
  "邀请码": "รหัสเชิญ",
  "提示": "คำแนะนำ",
  "请输入验证码": "กรุณากรอกรหัสยืนยัน",
  "姓名": "ชื่อ",
  "邮箱登录": "เข้าสู่ระบบด้วยอีเมล",
  "邮箱": "อีเมล",
  "密码": "รหัสผ่าน",
  "新用户": "ผู้ใช้ใหม่",
  "立即加入": "เข้าร่วมทันที",
  "忘记密码": "ลืมรหัสผ่าน",
  "登录": "เข้าสู่ระบบ",
  "无需开户,立即创建模拟账号进行交易!": "ไม่ต้องเปิดบัญชี, สร้างบัญชีจำลองและเริ่มการซื้อขายทันที!",
  "电话": "โทรศัพท์",
  "再次输入密码": "กรุณากรอกรหัสผ่านอีกครั้ง",
  "职业": "อาชีพ",
  "年收入": "รายได้ประจำปี",
  "注册": "ลงทะเบียน",
  "邮箱注册": "ลงทะเบียนด้วยอีเมล",
  "发送": "ส่ง",
  "重置密码": "รีเซ็ตรหัสผ่าน",
  "是否重置": "คุณต้องการรีเซ็ตรหัสผ่านหรือไม่",
  "已重置": "รีเซ็ตเรียบร้อย",
  "名称": "ชื่อ",
  "注册成功": "ลงทะเบียนสำเร็จ",
  "加载中": "กำลังโหลด",
  "您还未登录，请先登录": "คุณยังไม่ได้เข้าสู่ระบบ, กรุณาเข้าสู่ระบบก่อน",
  "退出成功": "ออกจากระบบสำเร็จ",
  "市价": "ราคาตลาด",
  "挂单": "คำสั่งรอดำเนินการ",
  "倍数": "จำนวนคูณ",
  "止盈": "ราคาทำกำไร",
  "止损": "ราคาหยุดขาดทุน",
  "买入数量": "จำนวนที่ซื้อ",
  "每手": "จำนวนต่อสัญญา",
  "预估手续费": "ค่าธรรมเนียมที่คาดว่าจะเกิดขึ้น",
  "预估保证金": "มาร์จิ้นที่คาดว่าจะเกิดขึ้น",
  "买入": "ซื้อ",
  "卖出": "ขาย",
  "您的订单已确认": "คำสั่งซื้อของคุณได้รับการยืนยัน",
  "订单页面": "หน้าคำสั่งซื้อ",
  "盈亏": "กำไร/ขาดทุน",
  "当前保证金": "มาร์จิ้นปัจจุบัน",
  "订单详情": "รายละเอียดคำสั่งซื้อ",
  "保证金": "มาร์จิ้น",
  "平仓": "ปิดตำแหน่ง",
  "修改": "แก้ไข",
  "手数": "จำนวนสัญญา",
  "暂无数据": "ไม่มีข้อมูล",
  "历史": "ประวัติ",
  "价格": "ราคา",
  "请输入价格": "กรุณากรอกราคา",
  "手": "สัญญา",
  "搜索结果": "ผลการค้นหา",
  "搜索产品": "ค้นหาผลิตภัณฑ์",
  "持仓": "ตำแหน่ง",
  "语言": "ภาษา",
  "审核中": "กำลังตรวจสอบ",
  "请上传证件照正/反面": "กรุณาอัปโหลดภาพด้านหน้า/ด้านหลังของเอกสาร",
  "上传成功": "อัปโหลดสำเร็จ",
  "上传失败": "อัปโหลดล้มเหลว",
  "提交成功": "ส่งสำเร็จ",
  "删除": "ลบ",
  "删除成功": "ลบสำเร็จ",
  "提币": "ถอนเงิน",
  "缺少参数或传值错误": "ขาดพารามิเตอร์หรือเกิดข้อผิดพลาดในการส่งค่า",
  "操作成功": "ดำเนินการสำเร็จ",
  "充值金额": "จำนวนที่ฝาก",
  "类型": "ประเภท",
  "状态": "สถานะ",
  "时间": "เวลา",
  "单位": "หน่วย",
  "最高价": "ราคาสูงสุด",
  "最低价": "ราคาต่ำสุด",
  "开盘价": "ราคาหุ้นเปิด",
  "请注册或登录真实账号": "กรุณาลงทะเบียนหรือเข้าสู่ระบบบัญชีจริง",
  "没有更多了": "ไม่มีข้อมูลเพิ่มเติม",
  "提现金额": "จำนวนที่ถอน",
  "审核通过": "การตรวจสอบผ่าน",
  "审核不通过": "การตรวจสอบไม่ผ่าน",
  "重新提交": "ส่งใหม่",
  "止盈价": "ราคาทำกำไร",
  "止损价": "ราคาหยุดขาดทุน",
  "总盈亏": "กำไร/ขาดทุนรวม",
  "撤单": "ยกเลิกคำสั่ง",
  "请先进行实名认证": "กรุณาทำการยืนยันตัวตนก่อน",
  "产品列表": "รายการผลิตภัณฑ์",
  "下单": "สั่งซื้อ",
  "可用资金": "เงินทุนที่ใช้ได้",
  "欢迎登录": "ยินดีต้อนรับเข้าสู่ระบบ",
  "可用": "ใช้ได้",
  "冻结": "ถูกแช่แข็ง",
  "财务记录": "บันทึกการเงิน",
  "交易对": "คู่การซื้อขาย",
  "开仓时间": "เวลาเปิดตำแหน่ง",
  "收益": "ผลกำไร",
  "操作": "ดำเนินการ",
  "下单价": "ราคาสั่งซื้อ",
  "当前价": "ราคาปัจจุบัน",
  "订单号": "หมายเลขคำสั่งซื้อ",
  "请选择": "กรุณาเลือก",
  "卖出(做空)止损价不能低于开仓价": "ราคาหยุดขาดทุนในการขาย (short) ไม่สามารถต่ำกว่าราคาที่เปิดตำแหน่ง",
  "卖出(做多)止盈价不能高于开仓价": "ราคาทำกำไรในการขาย (long) ไม่สามารถสูงกว่าราคาที่เปิดตำแหน่ง",
  "买入(做多)止损价不能高于开仓价": "ราคาหยุดขาดทุนในการซื้อ (long) ไม่สามารถสูงกว่าราคาที่เปิดตำแง่ง",
  "买入(做多)止盈价不能低于开仓价": "ราคาทำกำไรในการซื้อ (long) ไม่สามารถต่ำกว่าราคาที่เปิดตำแหน่ง",
  "买入(做多)止盈价不能低于开仓价和现价": "ราคาทำกำไรในการซื้อ (long) ไม่สามารถต่ำกว่าราคาที่เปิดตำแหน่งและราคาปัจจุบัน",
  "买入(做多)止损价不能高于开仓价和现价": "ราคาหยุดขาดทุนในการซื้อ (long) ไม่สามารถสูงกว่าราคาที่เปิดตำแหน่งและราคาปัจจุบัน",
  "卖出(做空)止损价不能低于开仓价和现价": "ราคาหยุดขาดทุนในการขาย (short) ไม่สามารถต่ำกว่าราคาที่เปิดตำแหน่งและราคาปัจจุบัน",
  "卖出(做多)止盈价不能高于开仓价和现价": "ราคาขาย (ซื้อ) ขายทำกำไรต้องไม่สูงกว่าราคาเปิดและราคาปัจจุบัน",

  "提现手续费": "ค่าธรรมเนียมการถอนเงิน",
  "提现退回": "การถอนเงินและการส่งคืน",
  "系统加款": "การเพิ่มระบบ",
  "系统减款": "ระบบลด",

  "交易周期": "รอบการซื้อขาย",
  "秒": "วินาที",
  "交易额": "ปริมาณเงินในการ",
  "买涨": "ซื้อโดยคาดหวังว่ามันจะเพิ่มขึ้น",
  "买跌": "ซื้อโดยคาดหวังว่ามันจะลดลง",
  "秒数": "จำนวนวินาที",
  "交易类型": "ประเภทการ",
  "看涨": "มีความคาดหวังว่ามันจะเพิ่มขึ้น",
  "看跌": "มีความคาดหวังว่ามันจะลดลง",
  "剩余时间": "เวลาที่เหลือ",
  "买入价": "ราคาซื้อ",
  "结算价": "ราคาที่ต้องชำระ",
  "交易额": "ปริมาณเงินในการ",
  "下单时间": "เวลาในการสั่งซื้อ",
  "结算时间": "เวลาที่ต้องชำระ",
  "该币种暂无交易": "ไม่มีการซื้อขายชั่วคราวในสกุลเงินนี้",

  "总资产": "ทั้งหมดของสินทรัพย์",
  "币种": "สกุลเงิน",
  "资产折合": "การแปลงค่าสินทรัพย์",
  "冻结金额": "จำนวนเงินที่ถูกระงับ",
  "可用金额": "จำนวนเงินที่สามารถใช้",
  "公司资产": "สินทรัพย์ของ회사",
  "请输入旧密码": "กรุณาป้อนรหัสผ่านเดิม",
  "请输入新密码": "กรุณาป้อนรหัสผ่านใหม่",
  "请再次输入新密码": "กรุณาป้อนรหัสผ่านใหม่อีกครั้ง",
  "白皮书": "หนังสือขาว",
  "注册证书": "ใบรับรองการลงทะเบียน",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "สิทธิ์ในการอธิบายสุดท้ายของข้อมูลดังกล่าวเป็นของทางการรับรอง",
  "上一页": "หน้าแล้ว",
  "下一页": "หน้าถัดไป",
  "关闭": "ปิด",
  "闪电兑换": "การแลกเปลี่ยนด้วยความไว",
  "全部": "ทั้งหมด",
  "可用余额": "ยอดเงินที่สามารถใช้",
  "到": "ถึง",
  "请输入数量": "กรุณาป้อนจำนวน",
  "币种选择": "การเลือกสกุลเงิน",
  "从": "จาก",
  "兑换": "แลกเปลี่ยน",
  "兑换成功！": "การแลกเปลี่ยนสำเร็จ!",
  "支付": "ชำระ",
  "全部兑换成功": "การแลกเปลี่ยนทั้งหมดสำเร็จ",
  "获取": "รับ",
  "数量": "ปริมาณ",
  "拒绝原因": "เหตุผลในการปฏิเสธ",
  "交易密码": "รหัสผ่านการซื้อขาย",
  "设置交易密码": "ตั้งรหัสผ่านการซื้อขาย",
  "重置交易密码": "รีเซ็ตรหัสผ่านการซื้อขาย",
  "确定": "ยืนยัน",
  "是否购买？": "ซื้อหรือไม่?",
  "外汇": "อัตราแลกเปลี่ยน",
  "期权": "ออปชั่น",
  "(用户中心)": "(ศูนย์ผู้ใช้)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "ธุรกรรมของคุณกำลังได้รับการดำเนินการ กรุณารออย่างอดทนเพื่อให้ธุรกรรมเสร็จสมบูรณ์ก่อนดำเนินการอื่น ๆ !",
  "继续下单": "ดำเนินการสั่งซื้อ",
  "交易方向": "ทิศทางการซื้อขาย",
  "实现盈利": "ทำกำไร",
  "最新价格": "ราคาล่าสุด",
  "结算完成": "การชำระเงินเสร็จสิ้น",
  "下单余额不足": "ยอดคงเหลือไม่เพียงพอในการสั่งซื้อ",
  "输入交易额度": "กรอกจำนวนธุรกรรม",
  "选择交易周期": "เลือกระยะเวลาการเทรด",
  "审核拒绝": "การตรวจสอบถูกปฏิเสธ",
  "请输入正确的数量!": "กรุณากรอกจำนวนที่ถูกต้อง!",
  "上传身份": "อัพโหลดบัตรประชาชน",
  "上传正面": "อัพโหลดด้านหน้า",
  "上传反面": "อัพโหลดด้านหลัง",
  "完善信息": "กรอกข้อมูลให้ครบถ้วน",
  "输入姓名": "กรอกชื่อ",
  "输入身份证号": "กรอกหมายเลขบัตรประชาชน",
  "身份证号": "หมายเลขบัตรประชาชน",
  "请上传证件照正/反面": "กรุณาอัพโหลดภาพบัตรประชาชนด้านหน้า/ด้านหลัง",
  "最小提现金额10USDT": "จำนวนเงินถอนขั้นต่ำคือ 10 USDT",
  "证件号码": "หมายเลขบัตรประชาชน",
  "输入证件号码": "กรอกหมายเลขบัตรประชาชน",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "กรุณาอัปโหลดบัตรประชาชน, ใบขับขี่ หรือหนังสือเดินทางเพื่อการยืนยันตัวตน!"


}
